// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Input, Select } from 'antd'
import { ToastContainer } from 'react-toastify'
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs'
import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { Loading } from '../../components/Loading/Loading'
import { Pagination } from '../../components/Pagination/Pagination'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import DatesPicker from '../../components/Calendar/datePicker'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import { whatsappMask } from '../../utils/masks'
import { useMensagensEnviadas } from './useMensagensEnviadas'
import { WrapperCards } from '../Dashboard/DashBoard.style'
import {
  Container,
  FilterBar,
  FilterField,
  SearchSuffix,
  Tag,
  Remetente,
  TableWrapper,
} from './MensagensEnviadas.style'

function canalLabel(canal: string): string {
  return canal === 'EMAIL' ? 'E-mail' : 'WhatsApp'
}

// E-mail não tem remetente de WhatsApp. WhatsApp sem número é mensagem enviada antes de o sistema
// registrar o remetente: não há como reconstruir, então a tela diz isso em vez de deixar em branco.
function RemetenteCelula({
  item,
}: {
  item: GetMensagensEnviadasType['content'][number]
}) {
  if (item.canal !== 'WHATSAPP') {
    return <span>-</span>
  }
  if (!item.remetenteNumero) {
    return <Remetente.Ausente>não registrado</Remetente.Ausente>
  }
  return (
    <Remetente.Bloco>
      <span>{whatsappMask(item.remetenteNumero)}</span>
      {item.remetenteOrigem && (
        <Remetente.Origem>
          {item.remetenteOrigem === 'PESSOAL' ? 'Pessoal' : 'Organização'}
        </Remetente.Origem>
      )}
    </Remetente.Bloco>
  )
}

function StatusTag({ status }: { status: string }) {
  if (status === 'ENVIADO') {
    return (
      <Tag background={colors.lightGreen} color={colors.secondaryText}>
        Enviado
      </Tag>
    )
  }
  return (
    <Tag background={colors.lightRed} color={colors.errorText}>
      Falha
    </Tag>
  )
}

export function MensagensEnviadas() {
  const {
    mensagens,
    resumo,
    isLoading,
    currentPage,
    setCurrentPage,
    canal,
    status,
    remetente,
    remetentesDisponiveis,
    onChangeCanal,
    onChangeStatus,
    onChangeRemetente,
    onChangeDataInicio,
    onChangeDataFim,
    onChangeQuery,
    exportar,
    isExportando,
    goToDetalhe,
  } = useMensagensEnviadas()

  return (
    <Container>
      <ToastContainer theme="dark" />
      <ContainerTitle>
        <DivTitle color={colors.primaryText} size={24}>
          Mensagens enviadas
        </DivTitle>
      </ContainerTitle>

      <WrapperCards>
        <CardDashboard
          colorTitle={colors.white}
          color={colors.white}
          background={colors.grey200}
          total={resumo.total || 0}
        >
          Total
        </CardDashboard>
        <CardDashboard
          colorTitle={colors.grey900}
          color={colors.primaryText}
          background={colors.surface}
          total={resumo.totalEmail || 0}
        >
          E-mails
        </CardDashboard>
        <CardDashboard
          colorTitle={colors.grey900}
          color={colors.primaryText}
          background={colors.surface}
          total={resumo.totalWhatsapp || 0}
        >
          WhatsApp
        </CardDashboard>
        <CardDashboard
          colorTitle={colors.grey900}
          color={colors.primaryText}
          background={colors.surface}
          total={resumo.totalFalha || 0}
        >
          Falhas
        </CardDashboard>
      </WrapperCards>

      <FilterBar>
        <FilterField>
          <span>Canal</span>
          <Select
            mode="multiple"
            allowClear
            placeholder="Todos"
            style={{ minWidth: 180 }}
            value={canal}
            onChange={onChangeCanal}
            options={[
              { value: 'EMAIL', label: 'E-mail' },
              { value: 'WHATSAPP', label: 'WhatsApp' },
            ]}
          />
        </FilterField>
        <FilterField>
          <span>Status</span>
          <Select
            mode="multiple"
            allowClear
            placeholder="Todos"
            style={{ minWidth: 180 }}
            value={status}
            onChange={onChangeStatus}
            options={[
              { value: 'ENVIADO', label: 'Enviado' },
              { value: 'FALHA', label: 'Falha' },
            ]}
          />
        </FilterField>
        <FilterField>
          <span>Remetente (WhatsApp)</span>
          <Select
            mode="multiple"
            allowClear
            placeholder="Todos"
            style={{ minWidth: 220 }}
            value={remetente}
            onChange={onChangeRemetente}
            notFoundContent="Nenhum remetente registrado"
            options={remetentesDisponiveis.map(numero => ({
              value: numero,
              label: whatsappMask(numero),
            }))}
          />
        </FilterField>
        <FilterField>
          <span>De</span>
          <DatesPicker
            size="150px"
            background
            handleDataSelecionada={onChangeDataInicio}
          />
        </FilterField>
        <FilterField>
          <span>Até</span>
          <DatesPicker
            size="150px"
            background
            handleDataSelecionada={onChangeDataFim}
          />
        </FilterField>
        <FilterField>
          <span>Buscar</span>
          <Input
            allowClear
            placeholder="Destinatário, cliente ou assunto"
            style={{ width: 260, height: 32 }}
            suffix={
              <SearchSuffix>
                <SearchIcon />
              </SearchSuffix>
            }
            onChange={event => onChangeQuery(event.target.value)}
          />
        </FilterField>
        {/* Exporta o recorte INTEIRO dos filtros, não só a página. Desabilitado durante o refetch
            (a tabela ainda mostraria o recorte anterior) e sem linha (arquivo vazio não serve). */}
        <Button
          style={{ marginLeft: 'auto' }}
          onClick={exportar}
          loading={isExportando}
          disabled={isExportando || isLoading || !mensagens.totalElements}
        >
          {isExportando ? 'Gerando…' : 'Exportar Excel'}
        </Button>
      </FilterBar>

      <TableWrapper>
        <GenericTable
          font="14px"
          spacing="16px"
          vendas
          headers={[
            'Canal',
            'Destinatário',
            'Remetente',
            'Cliente',
            'Status',
            'Usuário',
            'Data/hora',
          ]}
        >
          {isLoading ? (
            <Loading contrast={false} />
          ) : (
            <>
              {Array.isArray(mensagens.content) &&
                mensagens.content.map(item => (
                  <tr key={item.id} onClick={() => goToDetalhe(item.id)}>
                    <td>{canalLabel(item.canal)}</td>
                    <td>{item.destinatario}</td>
                    <td>
                      <RemetenteCelula item={item} />
                    </td>
                    <td>{item.clienteNome || '-'}</td>
                    <td>
                      <StatusTag status={item.status} />
                    </td>
                    <td>{item.usuarioEmail || '-'}</td>
                    <td>{dayjs(item.dataHora).format('DD/MM/YYYY HH:mm')}</td>
                  </tr>
                ))}
              {Array.isArray(mensagens.content) &&
                mensagens.content.length === 0 && (
                  <tr>
                    <td colSpan={7}>Nenhuma mensagem encontrada.</td>
                  </tr>
                )}
            </>
          )}
        </GenericTable>
      </TableWrapper>

      {mensagens && mensagens.totalElements > 0 && (
        <Pagination
          pageNumber={currentPage}
          pageSize={mensagens.totalElements}
          offSet={mensagens.size}
          onClick={page => setCurrentPage(page)}
        />
      )}
    </Container>
  )
}
